// General
export const ERROR = 'ERROR';
export const LOGGED_IN = 'updateAuthState';
export const SET_AUTH_CREDENTIALS = 'setAuthCredentials';
export const SET_LOADING = 'SET_LOADING';
export const SET_NUMBERS = 'SET_NUMBERS';
export const SET_HISTORY = 'SET_HISTORY';
export const SET_SEARCH_NUMBER = 'SET_SEARCH_NUMBER';
export const SET_VERIFY_NUMBER_ID = 'SET_VERIFY_NUMBER_ID';
export const SET_VERIFY_NUMBER_ERR = 'SET_VERIFY_NUMBER_ERR';
export const SET_AUTH = 'SET_AUTH';
export const SET_AUTH_ERR = 'SET_AUTH_ERR';
export const CLEAN_UP_AUTH = 'CLEAN_UP_AUTH';
export const SET_STATUS = 'SET_STATUS';
export const SET_IN_CONVERSATION = 'SET_IN_CONVERSATION';
export const SET_USER_ACTIVE_CALL = 'SET_USER_ACTIVE_CALL';
export const SET_USER_LOGIN_NUMBER = 'SET_USER_LOGIN_NUMBER';
export const SET_SEARCH_NUMBER_ERR = 'SET_SEARCH_NUMBER_ERR';
export const SET_ALL_BRIDGES = 'SET_ALL_BRIDGES';
export const SET_PROFILE_NAME = 'SET_PROFILE_NAME';
export const SET_DOMAIN_USERS = 'SET_DOMAIN_USERS';
export const SET_SEARCHED_BRIDGE = 'SET_SEARCHED_BRIDGE';
export const SET_POLLING_STATUS = 'SET_POLLING_STATUS';
export const SET_API_ERROR = 'SET_API_ERROR';
export const SET_ADMIN_LAYOUT = 'SET_ADMIN_LAYOUT';
export const SET_BRIDGE_ERROR = 'SET_BRIDGE_ERROR';
export const CLEANUP_SEARCH_DATA = 'CLEANUP_SEARCH_DATA';
